function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo } from 'react';
import { Row, Col, InputGroup, Input, Label } from 'reactstrap';
import { _translate } from "../../../../../../services/core";
import { useWorkFlow } from "../../../../../contexts/workflow";
import Select from 'react-select';
import { useQuestion } from "../../../../../question/question-context";
import { useJourney } from "../../use-utils";
import Icon from "../../../../../common/icon";
import Single from "../../timer/single";

/**
 * Le but de cette page est d'afficher les 3 Autcomplètes pour aller
 * chercher les arrets de départ/arrivée et la ligne utilisée
 * Il faut affficher seulement pour TP. Liste à définir dans la question
 */
var Transport = function Transport(_ref) {
  var _currentQuestion$publ;
  var _onChange = _ref.onChange,
    index = _ref.index,
    className = _ref.className;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentQuestion = collector.currentQuestion;
  var _useQuestion = useQuestion(),
    _useQuestion2 = _slicedToArray(_useQuestion, 1),
    journey = _useQuestion2[0];
  var stepJourney = journey[index];
  var q_carpooling_app = (_currentQuestion$publ = currentQuestion.publicParameters) === null || _currentQuestion$publ === void 0 ? void 0 : _currentQuestion$publ.q_carpooling_app;
  if (!stepJourney || !stepJourney.mode || !q_carpooling_app) {
    return null;
  }
  q_carpooling_app = q_carpooling_app.split(',').map(function (el) {
    return el.trim();
  });
  var display = false;
  stepJourney.mode.categories.forEach(function (category) {
    if (q_carpooling_app.includes(category.name)) {
      display = true;
    }
  });
  var getOptions = function getOptions() {
    return [{
      value: 'Karos',
      label: 'Karos'
    }, {
      value: 'Klaxit',
      label: 'Klaxit'
    }, {
      value: 'Ecov',
      label: 'Ecov'
    }, {
      value: 'Blablacar Daily',
      label: 'Blablacar Daily'
    }, {
      value: 'Rezo Pouce',
      label: 'Rezo Pouce'
    }, {
      value: 'no_app',
      label: _translate('collectorapp_no_app')
    }];
  };
  if (!display) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-3 ".concat(className),
    key: "".concat(stepJourney.mode, "_").concat(parseInt(Math.random() * 1000))
  }, /*#__PURE__*/React.createElement(Row, {
    className: "w-100 p-0"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    lg: "6",
    className: "col d-flex align-items-center justify-content-end text-right"
  }, /*#__PURE__*/React.createElement("span", null, _translate('collectorapp_journey_covoit_app'))), /*#__PURE__*/React.createElement(Col, {
    sm: "6",
    xs: "6",
    lg: "4",
    className: "p-0 d-flex align-items-center justify-content-cente mx-auto"
  }, /*#__PURE__*/React.createElement(Select, {
    options: getOptions(),
    onChange: function onChange(option) {
      return _onChange(option.value, "carpooling_app");
    },
    value: stepJourney.carpooling_app ? {
      label: _translate(stepJourney.carpooling_app),
      value: stepJourney.carpooling_app
    } : null,
    className: "w-100",
    placeholder: _translate('collectorapp_choose_apps')
  }))));
};
export default /*#__PURE__*/memo(Transport);